import { ModulesMap } from '@/config/data/modulesMaps'
import LandsCadastralCasesApi from '@/services/apiServiceModules/landsCadastralCasesApi'
import DataTransferModule from '@/services/dataTransferModule'

const landsCadastralCasesApi = new LandsCadastralCasesApi()

export default class LandsCadastralCasesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LANDS_CADASTRAL_CASES, landsCadastralCasesApi, {
			useCache: true,
		})
	}
}
